import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import LearnosityItemTags from 'legacy-src/utility/LearnosityItemTags';
import ItemTags from 'legacy-src/utility/ItemTags';
import { setMathJaxTypeset } from 'chameleon-src/utility/utils';
import LearnosityItemPreview from 'legacy-src/components/learnosity/LearnosityItemPreview';
import ResponsiveView from 'legacy-src/utility/ResponsiveView';
import PlayerGuidelines from 'legacy-src/shared/PreviewPlayer/PlayerGuidelines';
import { BluebookContext } from 'chameleon/packages/blue-book-player/state/BluebookContext';

const QuestionDetails = (props) => {
  const [isReady, setIsReady] = useState(false);
  const [toggleStatus, setToggleStatus] = useState(false);
  const [learnosityItems, setLearnosityItems] = useState([]);
  const { state: playerState } = useContext(BluebookContext);
  const {
    itemId,
    questions,
    subject,
    learnosityApp,
    showGrayTopRightBarPreview,
    userData: { isStudent },
    setAreDetailsExpanded,
    areDetailsExpanded,
  } = props;

  useEffect(() => {
    if (playerState.isTestReady) {
      const items = learnosityApp?.getItems();
      setLearnosityItems(items);
    }
  }, [playerState.isTestReady, learnosityApp]);

  const handleQuestionDetailsToogleRationale = (newState) => {
    setToggleStatus(newState);
  };

  const handleToggleExpansion = (newState) => {
    setAreDetailsExpanded(newState);
  };

  const isScoringRubricsAvailable = !isStudent && toggleStatus;

  useEffect(() => {
    if (playerState.isTestReady) {
      setTimeout(() => {
        setIsReady(true);
      }, 500);
    }
  }, [playerState.isTestReady]);

  return (
    <div
      className={cn('absolute right-0 h-screen bg-bluebook-gray8', {
        'w-[30%] details-expanded': areDetailsExpanded,
        'w-[52px] details-collapsed': !areDetailsExpanded,
      })}
    >
      {!isStudent && isReady && (
        <>
          <ResponsiveView screens={['medium', 'large']}>
            {(!isEmpty(learnosityItems) && (
              <PlayerGuidelines
                isPreApSubject={subject?.isPreApSubject}
                questions={questions}
                isVisible={isScoringRubricsAvailable}
                learnosityData={{
                  app: learnosityApp,
                  items: learnosityItems,
                }}
                isBlueBook
              />
            )) ||
              null}
          </ResponsiveView>
          <LearnosityItemPreview
            responseAnalysis={[]}
            assignmentReport={{}}
            students={[]}
            studentUrl=""
            studentId={false}
            isStudent={false}
            showAnalysis={false}
            isBluebook
          />
        </>
      )}
      {playerState.isTestReady && (
        <LearnosityItemTags
          itemId={Number(itemId, 10)}
          questions={questions}
          subjectId={subject?.id}
          questionDetailsToogleRationale={handleQuestionDetailsToogleRationale}
          learnosityData={{ app: learnosityApp }}
        >
          <ItemTags
            onLoad={(element) => {
              setMathJaxTypeset(element);
            }}
            questionDetailsToogleRationale={
              handleQuestionDetailsToogleRationale
            }
            handleToggleExpansion={handleToggleExpansion}
            showGrayTopRightBarPreview={showGrayTopRightBarPreview}
          />
        </LearnosityItemTags>
      )}
    </div>
  );
};

QuestionDetails.propTypes = {
  learnosityServerData: PropTypes.object.isRequired,
  questions: PropTypes.array.isRequired,
  allowCalculatorForItems: PropTypes.array.isRequired,
  itemId: PropTypes.string.isRequired,
  subject: PropTypes.object.isRequired,
  learnosityApp: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  setAreDetailsExpanded: PropTypes.func.isRequired,
  areDetailsExpanded: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  const { featureFlag } = state;
  return {
    showGrayTopRightBarPreview: featureFlag.show_gray_top_right_preview_player,
  };
};

export default connect(mapStateToProps)(QuestionDetails);
